import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import ruleEditorHelpImage from '../../../assets/images/ruleEditorHelp.png';
import {LearnMoreButton} from '../../../components/common/callToAction/learnMoreButton';
import {EducationTooltipCoordinator} from '../../../components/common/tooltips/educationTooltip/educationTooltipCoordinator';
import {PartialRuleModelStrict} from '../../../models/api/ruleModel';
import {InterfaceEventsEnum} from '../../../services/tracking';
import {RuleRecipe} from '../../../settings/rules/library/recipes';
import {trackRuleEvent} from '../../../settings/rules/ruleHelpers';

/*
 * Types.
 */

interface RuleEditorSidebarTooltipProps {
  rule?: PartialRuleModelStrict;
  namespace: string;
  recipe?: RuleRecipe;
}

/*
 * Style.
 */

const StyledRuleEditorSidebarHelpImage = styled.img`
  margin-top: 12px;
  width: 100%;
`;

/*
 * Component.
 */

export const RuleEditorSidebarTooltip: FC<RuleEditorSidebarTooltipProps> = ({rule, namespace, recipe}) => (
  <EducationTooltipCoordinator
    title={tooltip.title}
    tooltip={tooltip.tooltipContent}
    placement="bottom"
    buttons={[
      <LearnMoreButton
        size={VisualSizesEnum.SMALL}
        variant={ButtonVariantsEnum.PRIMARY}
        helpPageUrl={tooltip.learnMoreUrl}
        onClick={() =>
          trackRuleEvent(
            InterfaceEventsEnum.SETTINGS_DYNAMIC_VARIABLE_LEARN_MORE_CLICK,
            rule,
            namespace,
            recipe?.id,
          )
        }
      />,
    ]}
  />
);

/*
 * Helpers.
 */

const tooltip = {
  title: (
    <Trans id="rule-editor-expression-sidebar-variables-tooltip-title">What&apos;s a Dynamic Variable?</Trans>
  ),
  tooltipContent: (
    <div>
      <Trans id="rule-editor-expression-sidebar-variables-tooltip-content">
        Dynamic Variables are options you can build within a Smart Rule that adapt to the different traits of
        the conversations and actions.
      </Trans>
      <StyledRuleEditorSidebarHelpImage src={ruleEditorHelpImage} alt="" />
    </div>
  ),
  learnMoreUrl: 'https://help.front.com/t/y4hg1ck/smart-rules',
};
